import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { IdleTimeoutService } from '../../../core/services/idle-timeout/idle-timeout.service';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-idle-warning-dialog',
  imports: [MatButtonModule, MatDialogModule, IconComponent],
  templateUrl: './idle-warning-dialog.component.html',
  styleUrl: './idle-warning-dialog.component.scss',
})
export class IdleWarningDialogComponent {
  private idleTimeoutService = inject(IdleTimeoutService);

  timer: string | null = null;

  constructor() {
    this.idleTimeoutService.logoutCountdown$.subscribe(countdown => {
      const minutes = Math.floor(countdown / 60);
      let seconds = Math.floor(countdown % 60).toString();
      seconds = seconds.length > 1 ? seconds : 0 + seconds;
      this.timer = minutes + ':' + seconds;
    });
  }
}
